module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "krossing_row",
    style: (_vm.compStyle)
  }, [(_vm.height) ? _c('div', {
    staticClass: "krossing_row_height medium h8 upcase c-dgrey"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.height) + " CM\n\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row_container",
    class: [{
        editing: _vm.compIsEditing
      },
      {
        'disable-hover': _vm.disableHover === true
      },
      {
        enabled: _vm.compIsEnabled
      }
    ],
    on: {
      "click": _vm.emitOnClick
    }
  }, [_c('edituprightbtn', {
    attrs: {
      "is-visible": !!_vm.showEdit || _vm.disableHover !== true
    }
  }), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('adduprightbtn', {
    attrs: {
      "to-bottom": true,
      "is-visible": _vm.compShowAdd
    },
    on: {
      "click": function($event) {
        _vm.emitOnAdd()
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78f4c9f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/KrossingRow.vue
// module id = 647
// module chunks = 0